import i18n from 'i18n';
import { Helmet } from 'react-helmet';
import { LanguageType } from 'scheme/languageType';
import { parseLanguageType } from 'utils/parseLanguageType';

export default function PageHelmet() {
  const titleText = () => {
    switch (parseLanguageType(i18n.language)) {
      case LanguageType.EN:
        return `LoveyDovey Couple Theme - PlayKeyboard`;
      default:
        return `너랑나랑 꽁냥템 - 플레이키보드`;
    }
  };

  return (
    <Helmet>
      <title>{titleText()}</title>
    </Helmet>
  );
}
